import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  FormErrorMessage,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";

export default function PasswordForm({
  placeholder,
  name,
  handleChange,
  error,
}) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      <InputGroup>
        <Input
          type={showPassword ? "text" : "password"}
          name={name}
          onChange={(e) => handleChange(e)}
          placeholder={placeholder}
        />
        <InputRightElement
          children={
            <IconButton
              bgColor="transparent"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <ViewIcon /> : <ViewOffIcon />}
            </IconButton>
          }
        />
      </InputGroup>
    </div>
  );
}
